declare global {
  interface Window {
    RUNTIME_CONFIG?: Record<string, string | undefined>;
  }
}

const RUNTIME_CONFIG: Record<string, string | undefined> =
  typeof window !== 'undefined' && window.RUNTIME_CONFIG ? window.RUNTIME_CONFIG : {};

/**
 * Read a config value as a string:
 * - Prefer runtime value from window.RUNTIME_CONFIG
 * - Fallback to build-time env (globalThis.process?.env)
 * - Else use provided default (empty string by default)
 */
const getStr = (key: string, fallback = ''): string => {
  const fromRuntime = RUNTIME_CONFIG[key];
  if (typeof fromRuntime === 'string' && fromRuntime.trim() !== '') {
    return fromRuntime;
  }
  const fromBuild = process?.env?.[key] as string | undefined;
  if (typeof fromBuild === 'string' && fromBuild.trim() !== '') {
    return fromBuild;
  }
  return fallback;
};

export interface Config {
  keyRecaptchaSite: string;
  apiUrl: string;
  adminApiUrl: string;
  bookingUrl: string;
  authEndpoint: string;
  authTokenName: string;
  authClientId: string;
  authScope: string;
  authRedirectUrl: string;
  authLogoutEndpoint: string;
  patientAuthEndpoint: string;
  patientAuthTokenName: string;
  patientAuthClientId: string;
  patientAuthScope: string;
  patientAuthRedirectUrl: string;
  patientAuthLogoutEndpoint: string;
  portalUrl: string;
  googleMapsApiKey: string;
  gtagID: string;
}

const config: Config = {
  keyRecaptchaSite: getStr('VUE_APP_RECAPTCHA_SITE', ''),
  apiUrl: getStr('VUE_APP_API_URL', ''),
  adminApiUrl: getStr('VUE_APP_ADMIN_API_URL', ''),
  bookingUrl: getStr('VUE_APP_BOOKING_URL', ''),
  authEndpoint: getStr('VUE_APP_AUTH_ENDPOINT', ''),
  authTokenName: getStr('VUE_APP_AUTH_TOKEN_NAME', 'authToken'),
  authClientId: getStr('VUE_APP_AUTH_CLIENT_ID', ''),
  authScope: getStr('VUE_APP_AUTH_SCOPE', ''),
  authRedirectUrl: getStr('VUE_APP_AUTH_REDIRECT_URL', ''),
  authLogoutEndpoint: getStr('VUE_APP_AUTH_LOGOUT_ENDPOINT', ''),
  patientAuthEndpoint: getStr('VUE_APP_PATIENT_AUTH_ENDPOINT', ''),
  patientAuthTokenName: getStr('VUE_APP_PATIENT_AUTH_TOKEN_NAME', 'patientAuthToken'),
  patientAuthClientId: getStr('VUE_APP_PATIENT_AUTH_CLIENT_ID', ''),
  patientAuthScope: getStr('VUE_APP_PATIENT_AUTH_SCOPE', ''),
  patientAuthRedirectUrl: getStr('VUE_APP_PATIENT_AUTH_REDIRECT_URL', ''),
  patientAuthLogoutEndpoint: getStr('VUE_APP_PATIENT_AUTH_LOGOUT_ENDPOINT', ''),
  portalUrl: getStr('VUE_APP_PORTAL_URL', 'https://manage-my-appointments.aptvision.com'),
  googleMapsApiKey: getStr('VUE_APP_GOOGLE_MAPS_API_KEY', ''),
  gtagID: getStr('VUE_APP_GTAG_ID', '')
};

export default config;
